























import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import AttentionComponent from "@/components/app/Attention.vue";
import { Ref, Emit } from "vue-property-decorator";
import Cookies from "js-cookie";

@Component({
  components: {
    AttentionComponent
  }
})
export default class InlineFrame extends mixins(AxiosMixin) {
  @Ref("attention") private readonly attentionComponent!: AttentionComponent;
  private isAgree = false;
  private url = "";
  private height = 0;
  private releaseFlag = 0;
  private label = "上記に同意する";

  mounted() {
    this.postJsonCheck(
      window.base_url + "/api/iframe_url/get",
      {
        id: 1
      },
      res => {
        this.url = res.data.announce.url;
        this.height = res.data.announce.height;
        this.releaseFlag = res.data.release_flag;
        //2021/4/1より文言変更
        if (this.releaseFlag == 1) {
          this.label = "上記内容を確認しました";
        }
      }
    );
  }

  private clickStartButton() {
      this.attentionComponent.openDialog();
    // //2021/4/1よりダイアログ出ないようにする
    // if (this.releaseFlag == 0) {
    //   this.attentionComponent.openDialog();
    // } else {
    //   this.attention();
    // }
  }

  @Emit()
  private attention() {
    Cookies.set("isAgree", "true");
    return;
  }
}
